import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OptimizerSessionState {
  OptimizerSession: null | number;
}

const initialState: OptimizerSessionState = {
  OptimizerSession: null,
};

const OptimizerSessionSlice = createSlice({
  name: "OptimizerSession",
  initialState,
  reducers: {
    setOptimizerHPPCSession: (state, action: PayloadAction<number>) => {
      state.OptimizerSession = action.payload;
    },
    clearOptimizerSession: (state) => {
      state.OptimizerSession = null;
    },
  },
});

export const { setOptimizerHPPCSession, clearOptimizerSession } = OptimizerSessionSlice.actions;
export default OptimizerSessionSlice.reducer;
